import { BaseComponent } from '../../components/base-component'
import { hideElement, showElement } from '../../utils/dom'
import { $el, $list, transitionToPromise } from '../../utils/utils'

const ITEM_SELECTOR = `[data-list-item]`
const EXPAND_BTN_SELECTOR = `list-btn[data-trigger="expand"]`
const COLLAPSE_BTN_SELECTOR = `list-btn[data-trigger="collapse"]`
const VISIBLE_ITEM_SELECTOR = `${ITEM_SELECTOR}:not(.hidden)`
const HIDDEN_ITEM_SELECTOR = `${ITEM_SELECTOR}.hidden`

export class ListComponent extends BaseComponent {
  initialHeight: number
  maxHeight: number

  setInitialHeight(): void {
    this.initialHeight = Math.ceil(this.offsetHeight)
    this.style.maxHeight = `${this.initialHeight}px`
  }

  setHeight(): void {
    this.maxHeight = Math.ceil(this.scrollHeight)
    this.style.maxHeight = `${this.maxHeight}px`
  }

  collapse = (): void => {
    const expandBtn = $el(EXPAND_BTN_SELECTOR, this)
    const collapseBtn = $el(COLLAPSE_BTN_SELECTOR, this)

    this.hideItems()
    hideElement(collapseBtn)
    showElement(expandBtn)
    expandBtn.focus()
  }

  expand = (): void => {
    const collapseBtn = $el(COLLAPSE_BTN_SELECTOR, this)

    if (!this.initialHeight) {
      this.setInitialHeight()
    }

    this.showItems()

    this.tryHideExpandBtn()
    showElement(collapseBtn)
    collapseBtn.focus()

    this.setHeight()
  }

  hideItems(): void {
    const visibleItems = $list(VISIBLE_ITEM_SELECTOR, this)

    this.style.maxHeight = `${this.initialHeight}px`

    transitionToPromise(this).then(() => {
      visibleItems.forEach((node, index) => {
        const initialCount = this.dataset.initialCount
          ? +this.dataset.initialCount
          : 0

        if (index + 1 > +initialCount) {
          hideElement(node)
        }
      })
    })
  }

  showItems(): void {
    const hiddenItems = $list(HIDDEN_ITEM_SELECTOR, this)

    hiddenItems.forEach((node, index) => {
      const showCount = this.dataset.showCount ? this.dataset.showCount : 0

      if (index + 1 < +showCount) {
        showElement(node)
      }
    })

    this.style.maxHeight = `${this.maxHeight}px`
  }

  tryHideExpandBtn(): void {
    const expandBtn = $el(EXPAND_BTN_SELECTOR, this)
    const hiddenItems = $list(HIDDEN_ITEM_SELECTOR, this)

    if (hiddenItems.length === 0) {
      hideElement(expandBtn)
    }
  }
}
